import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginGuard } from './guards/login.guard';
import { LoginPage } from './pages/login/login.page';
import { TranslateModule } from '@ngx-translate/core';
import { ResetPasswordPage } from './pages/reset-password/reset-password.page';

const routes: Routes = [
  { path: 'loading', loadChildren: './pages/loading/loading.module#LoadingPageModule' },
  { path: 'login', component: LoginPage },
  { path: 'reset-password', component: ResetPasswordPage },
  {
    path: '',
    loadChildren: () => import('./pages/main/main.module').then(m => m.MainPageModule),
    canLoad: [LoginGuard]
  },
  { path: '', pathMatch: 'full', redirectTo: 'main/listado-incidencias'},
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    TranslateModule,
  ],
  exports: [
    RouterModule,
    TranslateModule,
  ],
})
export class AppRoutingModule {}
